exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-container[data-v-3605d0f6]{position:absolute;top:0;left:0;right:0;bottom:0;text-align:center}.loading-container .loading-backdrop[data-v-3605d0f6]{position:fixed;top:0;left:0;height:100%;width:100%;background-color:#d3d3d3;opacity:.5;z-index:9998}.loading-container .loading[data-v-3605d0f6]{z-index:9999;position:fixed;display:inline-block;background-color:#fff;padding:20px 50px;border-radius:12px;box-shadow:0 4px 8px 0 rgba(0,0,0,.2),0 6px 20px 0 rgba(0,0,0,.19);left:50%;top:50%;-ms-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.loading-container .loading .loading-icon[data-v-3605d0f6]{margin-bottom:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-blockui/dist/vue-blockui.css
// module id = G5oE
// module chunks = 0 1